import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { FlowState } from "../../pages/FlowPage";
import { BigButton } from "../BigButton";

interface Props {
  state: FlowState;
  onNext: (update: Partial<FlowState>) => void;
}

export function AmountStep({ state, onNext }: Props) {
  const { t } = useTranslation();
  const [raw, setRaw] = useState(
    state.amount_cents ? (state.amount_cents / 100).toFixed(2) : "",
  );
  const [error, setError] = useState("");

  function handleContinue() {
    const num = parseFloat(raw);
    if (isNaN(num) || num <= 0) {
      setError("Please enter a valid amount greater than $0.00.");
      return;
    }
    const cents = Math.round(num * 100);
    onNext({ amount_cents: cents });
  }

  return (
    <div className="flex flex-col gap-6 p-8 h-full justify-center">
      <h2 className="text-3xl font-bold text-center">
        {t("flow.amount.title")}
      </h2>
      <div className="relative">
        <span className="absolute left-4 top-1/2 -translate-y-1/2 text-3xl font-medium text-[var(--kiosk-brand-muted)]">
          {t("currency.symbol")}
        </span>
        <input
          type="number"
          inputMode="decimal"
          min="0.01"
          step="0.01"
          value={raw}
          onChange={(e) => {
            setRaw(e.target.value);
            setError("");
          }}
          placeholder={t("flow.amount.placeholder")}
          className="w-full rounded-[var(--kiosk-brand-radius)] border-2 border-[var(--kiosk-brand-primary)] pl-12 pr-6 py-4 text-4xl font-bold focus:outline-none focus:border-[var(--kiosk-brand-accent)] text-right"
          aria-label={t("flow.amount.title")}
          autoFocus
        />
      </div>
      {error && (
        <p role="alert" className="text-red-600 text-lg text-center">
          {error}
        </p>
      )}
      <BigButton
        variant="primary"
        fullWidth
        className="mt-auto"
        onClick={handleContinue}
        disabled={!raw || parseFloat(raw) <= 0}
      >
        {t("flow.amount.continue")}
      </BigButton>
    </div>
  );
}
